import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrentReservationService } from '@/common/services/reservation/current';

@Pipe({
    name: 'formatNumber',
})
export class FormatNumberPipe implements PipeTransform {
    constructor(private readonly reservation: CurrentReservationService) {}

    transform(
        value: number | string | null | undefined,
        prefix = '$',
        addPrefix = true,
    ): unknown {
        const numericValue = Number(value);
        const isInternational = this.reservation.current?.origin === 'INT';

        let formattedNumber: string;
        if (isInternational) {
            const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
            formattedNumber = formatNumber(safeValue, 'en-IN', '1.2-2');
        } else {
            const roundedValue = Number.isFinite(numericValue)
                ? Math.ceil(numericValue)
                : 0;
            formattedNumber = formatNumber(roundedValue, 'en-IN', '1.0-0');
        }

        return addPrefix ? `${prefix}${formattedNumber}` : formattedNumber;
    }
}
